// extracted by mini-css-extract-plugin
export default {"modal":"CreateTemplateModal-module__modal__qIV3j","content":"CreateTemplateModal-module__content__2RTun"};